export class InputMasks {
    static readonly phoneNumber = '(999) 999-9999';
    static readonly date = '99/99/9999';
    static readonly monthYear = '99/9999';
    static readonly zip = '99999';
    static readonly ssn = '999-99-9999';
    static readonly ein = '99-9999999';
    static readonly verificationCode = '999999';
  }
  